import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Heading, Image, ResponsiveContext, Text, TextInput } from "grommet";
import { Camera, Home, Qr } from "grommet-icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Attendee, useUser } from "../utils/AccountStore";
import Shapes from "../components/Shapes";
import LinkButton from "../components/LinkButton";
import { ExhibitorRow } from "./Exhibitors";

export const GetExhibitors = async () => {
    return axios.get(`${Server}/api/exhibitors`);
};

export interface Exhibitor {
    id: string;
    name: string;
    logo: string;
    description: string;
    isTreasure: boolean;
    location: string;
    website: string;
}

const TreasureHunt = () => {
    const { user, getUser } = useUser();
    const [statusText, setStatusText] = useState("Save");
    const [exhibitors, setExhibitors] = useState([] as Exhibitor[]);
    const [visitedTreasures, setVisitedTreasures] = useState([] as string[]);

    const treasures = [
        "/images/Aura QuestionMark.png",
        "/images/Creator QuestionMark.png",
        "/images/Gaming Question Mark.png",
        "/images/ISG QuestionMark.png",
        "/images/Moto QuestionMark.png",
        "/images/Services QuestionMark.png",
        "/images/Sponsors QuestionMark.png",
    ];

    const navigate = useNavigate();

    useEffect(() => {
        const load = async () => {
            try {
                await getUser();
                const res = await GetExhibitors();
                if (res.status === 200) {
                    setExhibitors(res.data.filter((e) => e.isTreasure));
                } else {
                    alert("Error getting exhibitors");
                    navigate("home");
                }
            } catch {
                alert("Error getting exhibitors");
                navigate("home");
            }
        };

        load();
    }, []);

    useEffect(() => {
        if (user.id) {
            setVisitedTreasures(user.visited);
        }
    }, [user]);

    return (
        <ResponsiveContext.Consumer>
            {(size) => (
                <Box pad="medium" align="center" fill>
                    <Grid columns={["1fr", "auto", "1fr"]} width="100%" align="center">
                        <Home color="brand" onClick={() => navigate("/home")} />
                        <Heading level="2" color="brand">
                            Exhibition Zone
                        </Heading>
                        <Box direction="row" gap="small" align="center" justify="end" onClick={() => navigate("/scanner")}>
                            <Text color="brand" weight={"bold"}>
                                Scan
                            </Text>
                            <Image src="/images/scanner.png" width={"25px"}></Image>
                        </Box>
                    </Grid>

                    <Text textAlign="center">Once you've visited a zone, scan the QR code provided.</Text>
                    {/* <Text textAlign="center">{user.email ? "Once you've completed a zone, scan the QR code to mark your progress." : "Enter your email to join the Product Experience"}</Text> */}
                    {/* {!user.email && <LinkButton path={"/profile"} label={"My Details"} primary color="brand"></LinkButton>} */}

                    <Grid columns={"medium"} gap="small" pad="small" justify="center" fill>
                        {exhibitors.map((exhibitor, i) => (
                            <>
                                {visitedTreasures.includes(exhibitor.id) ? (
                                    <ExhibitorRow exhibitor={exhibitor} onClick={() => navigate("/exhibitorDetails/" + exhibitor.id)} />
                                ) : (
                                    <Box background={"brand"} round="medium" pad="small" fill>
                                        <Grid columns={["40%", "auto"]} align="center">
                                            <Image src={treasures[i % treasures.length]} alt="Treasure" fit="contain" style={{ width: "100px", height: "100px" }} />
                                            <Text weight={"bold"} color="white">
                                                Unvisited
                                            </Text>
                                        </Grid>
                                    </Box>
                                )}
                            </>
                        ))}
                    </Grid>
                </Box>
            )}
        </ResponsiveContext.Consumer>
    );
};

export default TreasureHunt;
